import React from 'react';
import styled from 'styled-components';
import CheckBox from 'components/presenters/button/CheckBox';

export default function AccountDeleteConfirm({isChecked, handleChangeCheck}) {
    return (
        <AccountDeleteConfirmBlock>
            <AccountDeleteConfirmTitle>
                {'모티너스 탈퇴 전, 확인하세요'}
            </AccountDeleteConfirmTitle>
            <AccountDeleteConfirmDesc>
                {'탈퇴하시면 이용중인 모티너스 계정이 \n삭제되며, 모든 데이터는 복구가 불가능 합니다.'}
            </AccountDeleteConfirmDesc>
            <AccountDeleteInfoBlock>
                <AccountDeleteInfo>
                    <AccountDeleteUnderlineTxt>
                        {'인증 사진, 커뮤니티 게시글, 프로필, 포인트'}
                    </AccountDeleteUnderlineTxt>
                    {' 등 모든 정보가 삭제됩니다.'}
                </AccountDeleteInfo>
            </AccountDeleteInfoBlock>
            <AgreeTextBlock>
                <CheckBox checked={isChecked} onChange={handleChangeCheck}/>
                <AgreeText>{'안내 사항을 모두 확인하였으며, 이에 동의합니다.'}</AgreeText>
            </AgreeTextBlock>
        </AccountDeleteConfirmBlock>
    )
}

const AccountDeleteConfirmBlock = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: calc(100vw * (29 / 375)) calc(100vw * (17 / 375)) calc(100vw * (20 / 375)) calc(100vw * (17 / 375));
`;

const AccountDeleteConfirmTitle = styled.h1`
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (26 / 375));
    margin-bottom: calc(100vw * (19 / 375));
`;

const AccountDeleteConfirmDesc = styled.p`
    font-size: calc(100vw * (14 / 375));
    font-weight: 400;
    line-height: calc(100vw * (20 / 375));
    color: #121212;
    white-space: pre-wrap;
    margin-bottom: calc(100vw * (14 / 375));
`;

const AccountDeleteInfoBlock = styled.div`
    display: flex;
    align-items: center;
    background-color: #F7F7F7;
    padding: calc(100vw * (15 / 375)) calc(100vw * (12 / 375)) calc(100vw * (15 / 375)) calc(100vw * (12 / 375));
    border-radius: calc(100vw * (3 / 375));
    // height: calc(100vw * (47 / 375));
    color: #4E4E4E;
    margin-bottom: calc(100vw * (26 / 375));
`;

const AccountDeleteInfo = styled.p`
    font-size: calc(100vw * (11 / 375));
    font-weight: 400;
    line-height: calc(100vw * (23 / 375));
`;

const AccountDeleteUnderlineTxt = styled.span`
    border-bottom: 1px solid #4E4E4E;
`;

const AgreeTextBlock = styled.label`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

const AgreeText = styled.span`
    font-size: calc(100vw * (12 / 375));
    font-weight: 400;
    line-height: calc(100vw * (17.38 / 375));
`;